import { DevTool } from "@hookform/devtools";
import {
  Badge,
  BankAccountResolver,
  ModalContainer,
  SectionHeader,
  SectionSubheader,
  SwitchAppButton,
  SwitchAppIconButton,
} from "../../../components";
import {
  HookFormSelect,
  HookFormToggle,
  SubmitButton,
  TextArea,
  TextInput,
} from "../../../hook-form";
import { filterSupportedCountriesFromList } from "../../../utils";

import { IOnboardingStep3ViewProps } from "./OnboardingStep3";

export const View = ({
  isActive,

  handlePrevious,
  handleSubmit: handleSubmit,

  isLoadingSupportedCountries,
  swAppSupportedCountries,
  isLoadingSupportedCurrencies,
  swAppSupportedCurrencies,
  isLoadingBankList,
  bankList,

  bank_account_tags,
  appendBankAccountTag,
  removeBankAccountTag,

  isBankAccountResolved,
  setBankAccountResolved,

  formValues,
  errors: errors,
  register: register,
}: IOnboardingStep3ViewProps) => {
  return (
    <form onSubmit={handleSubmit}>
      <div className="onboarding-section">
        <SectionHeader
          title="Add your bank to receive payouts."
          subtitle="A payout is the transfer of earnings from your SwitchApp to your bank account."
        />

        <h5 className="form-section--title font-ctm--bold">Bank Details</h5>

        <HookFormSelect
          name="country"
          label="Country"
          infoIconText="Country where the withdrawal bank account is located"
          showSkeleton={isLoadingSupportedCountries}
          selectItems={[]}
          selectGroupedItems={filterSupportedCountriesFromList(
            swAppSupportedCountries
          )}
          register={register}
          errors={errors}
          disabled={!isActive}
        />

        <HookFormSelect
          name="currency"
          label="Currency"
          infoIconText="The currency of the withdrawal bank account eg USD"
          showSkeleton={isLoadingSupportedCurrencies}
          selectItems={swAppSupportedCurrencies.map((cur) => ({
            text: `${cur.currency_name} (${cur.currency_symbol})`,
            value: cur.currency,
          }))}
          register={register}
          errors={errors}
          disabled={!isActive || !formValues.country}
        />

        <HookFormSelect
          name="bank_code"
          label="Bank"
          infoIconText="The withdrawal bank"
          showSkeleton={isLoadingBankList}
          selectItems={bankList.map((bnk) => ({
            text: bnk.bank_name,
            value: bnk.bank_code,
          }))}
          register={register}
          errors={errors}
          disabled={!isActive || !formValues.country || !formValues.currency}
        />

        <TextInput
          name="account_number"
          label="Account Number"
          infoIconText="The withdrawal account number"
          type="text"
          register={register}
          errors={errors}
          disabled={!isActive}
        />

        <div className="flex-container">
          <BankAccountResolver
            accountNumber={formValues.account_number}
            bankCode={formValues.bank_code}
            country={formValues.country}
            currency={formValues.currency}
            isBankAccountResolved={isBankAccountResolved}
            setBankAccountResolved={setBankAccountResolved}
          />
        </div>

        {formValues.country !== "NG" ? null : (
          <TextInput
            name="bvn"
            label={`BVN ${formValues.country === "NG" ? "" : " (Optional)"}`}
            infoIconText="The Bank Verification Number connected to this account number"
            type="text"
            register={register}
            errors={errors}
          />
        )}

        {/* 
          <div className="flex-container justify-content--end">
            <HookFormToggle
              name="set_as_primary"
              label="Set As Primary Account Number"
              labelOff="No"
              labelOn="Yes"
              size="sm"
              containerClassName="settings-toggle"
              defaultToggled={formValues.set_as_primary}
              onToggle={onToggleSetPrimary}
              infoIconText={
                <>
                  Your primary account is where funds are deposited by default
                  unless otherwise specified.
                  <br />
                  NOTE: this will only be effected after account is verified.
                </>
              }
              register={register}
              errors={errors}
            />
          </div>
        */}

        <div>
          {bank_account_tags.map((tag, index) => (
            <div
              onClick={() => {
                if (window.confirm("Are you sure you want to remove this tag?"))
                  removeBankAccountTag(index);
              }}
            >
              <Badge
                text={tag.tag_name}
                hideIndicator
                statusColor="secondary"
              />
            </div>
          ))}
        </div>

        {/* <div className="flex-container col bordered b-r-5 mt-5 pl-5 pr-5">
          <SectionSubheader
            title="Payout Account Tag (Optional)"
            infoIconDescription="You may add a tag to your bank account if you intend to interact with our APIs"
          />
          <div className="flex-divider--horizontal"></div>

          <TextInput
            name="formHelperTagName"
            label="Tag Name"
            infoIconText="Tag name shown when paying out to this account number eg School Uniform Acct, Shop Sales Acct, etc. Leave empty if not applicable."
            type="text"
            register={register}
            errors={errors}
          />
          <TextArea
            name="formHelperTagDescription"
            label="Tag Description (Optional)"
            cols="70"
            infoIconText="More info about this tag."
            register={register}
            errors={errors}
          />

          <SwitchAppIconButton
            onClick={() =>
              appendBankAccountTag({
                tag_name: formValues.formHelperTagName,
                description: formValues.formHelperTagDescription,
              })
            }
          >
            Add Tag
          </SwitchAppIconButton>
        </div> */}

        <div className="flex-container buttons-container">
          {!isActive ? null : (
            <SwitchAppButton
              className="switchapp-themed onboarding-previous--button"
              kind="secondary"
              onClick={handlePrevious}
            >
              Previous
            </SwitchAppButton>
          )}

          {!isActive ? null : (
            <SubmitButton
              className="switchapp-themed onboarding-submit--button"
              disabled={!isBankAccountResolved}
            >
              Continue
            </SubmitButton>
          )}
        </div>
      </div>
    </form>
  );
};
